import { AxiosResponse } from 'axios';
import { apisiseci } from './api';

export const allActivities = ({ token, page }: { page: number; token: string; }): Promise<AxiosResponse> => {
  return apisiseci
    .get(`/core/eventos/carregar/?page=${page}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch((error) => {
      if (error.response?.status === 404) {
        return {
          data: { results: [] },
          status: 200,
          statusText: 'OK',
          headers: {},
          config: {},
        } as AxiosResponse;
      }
      throw error;
    });
};